import { useQuery } from "@tanstack/react-query";

import { quoteRequestsQuery } from "#modules/quoteRequests/infra/quoteRequests.query";
import { useQueryParams } from "#shared/helpers/useQueryParams";
import { QuoteRequestStatusType } from "shared";

export const useQuoteRequests = () => {
  const queryParams = useQueryParams();
  const page = queryParams.get("page");
  const status = queryParams.get("status") as QuoteRequestStatusType | null;
  const ownerId = queryParams.get("ownerId");
  const isFavorite = queryParams.get("isFavorite");

  const { data, ...rest } = useQuery({
    ...quoteRequestsQuery(page ? parseInt(page) : 1, {
      status: status || undefined,
      ownerId: ownerId || undefined,
      isFavorite: isFavorite ? Boolean(isFavorite) : undefined,
    }),
  });

  return { quoteRequests: data ?? [], ...rest };
};
